/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Latest_Reply_ColInputs */

const en_settings_tickets_latest_reply_col = /** @type {(inputs: Settings_Tickets_Latest_Reply_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Reply`)
};

const zh_settings_tickets_latest_reply_col = /** @type {(inputs: Settings_Tickets_Latest_Reply_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新回复`)
};

/**
* | output |
* | --- |
* | "Latest Reply" |
*
* @param {Settings_Tickets_Latest_Reply_ColInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_latest_reply_col = /** @type {((inputs?: Settings_Tickets_Latest_Reply_ColInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Latest_Reply_ColInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_latest_reply_col(inputs)
	return zh_settings_tickets_latest_reply_col(inputs)
});
export { settings_tickets_latest_reply_col as "settings.tickets.latest_reply_col" }